import './FormError.scss';
import * as React from 'react';
import { classList } from 'src/utils/classList';

type Props = React.HTMLProps<HTMLDivElement>;

export function FormError({ className, children, ...rest }: Props): JSX.Element {
    return <div className={classList('xss-form-error', className)}>{children}</div>;
}
